import { getRequestButtonConfig } from '../request/view';
export const config = getRequestButtonConfig('remove');
